const createMarkup = (text) => ({
  __html: text,
});

export default createMarkup;